module.exports = __webpack_public_path__ + "48f19420916bd09c982016411a6502dc.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-1024.webp.png
// module id = 450
// module chunks = 0